import { ReactNode } from 'react';

interface Props {
  title: string;
  url: string | null;
  loading: boolean;
  error: string | null;
  onClose: () => void;
  /** Controles opcionais (ex: inputs de placeholders) acima do preview. */
  children?: ReactNode;
}

export default function PdfPreviewModal({ title, url, loading, error, onClose, children }: Props) {
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h3 className="font-semibold truncate">{title}</h3>
          <div className="flex items-center gap-2">
            {url && (
              <a href={url} download className="btn btn-secondary text-xs py-1">
                Baixar PDF
              </a>
            )}
            <button onClick={onClose} className="text-slate-500 hover:text-slate-800 px-2 text-lg" aria-label="Fechar">
              ×
            </button>
          </div>
        </div>

        {children && <div className="px-4 py-3 border-b space-y-2 text-sm overflow-y-auto">{children}</div>}

        <div className="flex-1 min-h-[50vh] bg-slate-100">
          {loading && <div className="h-full flex items-center justify-center text-slate-500 text-sm">Gerando preview…</div>}
          {error && <div className="h-full flex items-center justify-center text-red-600 text-sm p-4 text-center">{error}</div>}
          {!loading && !error && url && (
            <iframe title="preview" src={url} className="w-full h-full min-h-[50vh]" />
          )}
          {!loading && !error && !url && (
            <div className="h-full flex items-center justify-center text-slate-400 text-sm">
              Preencha os valores e gere o preview.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
